<template>
  <div class="alert alert-danger" v-if="errorsFlatList.length">
    <ul class="mb-0">
      <li v-for="(error, index) in errorsFlatList" :key="index">
        {{ error }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    errors: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    errorsFlatList() {
      if (this.errors) {
        return Object.values(this.errors).flatMap(error => 
          Array.isArray(error) ? error : [error]
        );
      } else {
        return [];
      }
    },
  },
};
</script>